import { cx } from '../lib/cx.js';
import './spinner.css';

export interface SpinnerProps {
  size?: number;
  className?: string;
  /** Accessible label; omit when a parent already announces the busy state. */
  label?: string;
}

export function Spinner({ size = 14, className, label }: SpinnerProps) {
  return (
    <svg
      className={cx('vel-spinner', className)}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle className="vel-spinner__track" cx="8" cy="8" r="6.25" fill="none" strokeWidth="1.5" />
      <path
        className="vel-spinner__head"
        d="M8 1.75a6.25 6.25 0 0 1 6.25 6.25"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
